import type { ThemeOptions } from "@mui/material/styles";

export const transitionOptions: ThemeOptions["transitions"] = {
  duration: {
    enteringScreen: 300,
    leavingScreen: 300,
  },
};
